import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BhCrumbsComponent} from "./bh-crumbs.component";
import {AppTranslocoRootModule} from "../../../app.transloco.module";
import {RouterModule} from "@angular/router";
import {BhAssignmentsLabelBuilderModule} from "../bh-assignments-label-builder/bh-assignments-label-builder.module";
import {AppPipesModule} from "../../../app.pipes.module";


@NgModule({
  declarations: [BhCrumbsComponent],
  exports: [BhCrumbsComponent],
    imports: [
        CommonModule,
        AppTranslocoRootModule,
        RouterModule,
        BhAssignmentsLabelBuilderModule,
        AppPipesModule
    ]
})
export class BhCrumbsModule { }
